export enum LayerType {
  OSM_ROADS = "OSM:Roads",
  OSM_POI = "OSM:POI",
  PUBLIC_TRANSPORT = "Basemap:PublicTransport",
  OS_OPEN_ROADS = "OS:OpenRoads",
  OS_MRN = "OS:MRN",
  OS_HIGHWAYS = "OS:Highways",
  ROUTE_LINES = "Basemap:RouteLine",
  OS_POI = "OS:POI",
  OS_CODE_POINTS = "OS:CodePoints",
  INRIX_VOLUMES =  "Inrix:Volumes",
  INRIX_TRIPS = "Inrix:Trip",
  INRIX_SPEED_PROFILES = "Inrix:SpeedProfiles"
}
